import { apiGet } from './utils';
import type { AdminPayment, PagedResponse, PaymentRequestsResponse } from '../types';

export const adminPaymentApi = {
  /**
   * List the current assistant's payments
   */
  async list(cursor?: string): Promise<PagedResponse<AdminPayment>> {
    return apiGet<PagedResponse<AdminPayment>>('/admin-payment/list', { cursor });
  },

  /**
   * List payments for any user (sudo only)
   */
  async sudoList(userUuid: string, cursor?: string): Promise<PagedResponse<AdminPayment>> {
    return apiGet<PagedResponse<AdminPayment>>('/admin-payment/sudo-list', {
      user_uuid: userUuid,
      cursor,
    });
  },

  /**
   * List payments for any user (manager only)
   */
  async managerList(userUuid: string, cursor?: string): Promise<PagedResponse<AdminPayment>> {
    return apiGet<PagedResponse<AdminPayment>>('/admin-payment/manager-list', {
      user_uuid: userUuid,
      cursor,
    });
  },

  async fetchRequests(paymentKey: string): Promise<PaymentRequestsResponse> {
    return apiGet<PaymentRequestsResponse>('/admin-payment/requests', {
      payment_key: paymentKey,
    });
  },
};
